import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, Form, getFormValues, isSubmitting, isValid, reduxForm } from 'redux-form';
import SdsButton from '../../../../commons/containers/SdsButton';
import SdsError from '../../../../commons/containers/SdsError';
import SdsInput from '../../../../commons/containers/SdsInput';
import Divider from '../../../../commons/containers/Divider';
import { ROUTES } from '../../../../commons/routes/routes';
import {
	formatCnpj,
	formatCpfOuCnpj,
	obrigatorio,
	validateCnpjLogin,
	validateCpfOuCnpj
} from '../../../../commons/validation/validation';
import AppLoading from '../../../AppLayout/containers/AppLoading';
import './LoginForm.css';
import { LinkRouterStyled } from '../../../../commons/containers/LinkStyled';
import {
	consts as configConst,
	selectors as configuracacoesSelector
} from '../../../../redux/modules/configuracoes';

class LoginForm extends PureComponent {
	constructor(props) {
		super(props);

		this.recaptchaRef = React.createRef();
	}

	resetReCaptcha = () => {
		if (!this.props.captchaEnabled) {
			return;
		}
		this.recaptchaRef.current.reset();
	};

	validateReCaptcha = () => {
		if (!this.props.captchaEnabled) {
			return;
		}
		this.recaptchaRef.current.execute();
	};

	getReCaptcha = () => {
		if (!this.props.captchaEnabled) {
			return;
		}
		return this.recaptchaRef.current.getValue();
	};

	login = () => {
		var form = this.props.formLoginValues;

		var payload = {
			usuario: form.identificacao,
			senha: form.senha,
			redirectUrl: this.props.redirectUrl,
			redirecPageDefault: this.props.redirecPageDefault,
			captcha: this.getReCaptcha()
		};
		this.props.login(payload);
		this.resetReCaptcha();
	};

	render() {
		const {
			erro,
			loading,
			valid,
			submitting,
			handleSubmit,
			captchaEnabled,
			captchaSitekey,
			config
		} = this.props;

		// const fnHandleSubmit = captchaEnabled ? this.validateReCaptcha : this.login;
		const fnHandleSubmit = this.login;
		const fnSubmit = captchaEnabled ? this.login : this.validateReCaptcha;

		const identificacao = _.get(this.props, 'formLoginValues.identificacao');

		const usarObrasGov = config.EXIBE_BOTAO_GOV_BR_LOGIN;

		const validateUserName = [obrigatorio, usarObrasGov ? validateCnpjLogin : validateCpfOuCnpj];
		const labelUserName = usarObrasGov
			? 'LABELS.COMMONS.USUARIO.CNPJ'
			: 'LABELS.COMMONS.USUARIO.IDENTIFICACAO';
		const formatUserName = usarObrasGov ? formatCnpj : formatCpfOuCnpj;

		return (
			<section className="sds-container">
				<div className="sds-row sds-center-xs">
					<div className="sds-col-xs-12 sds-col-md-8 sds-col-lg-6">
						<div className="sds-card-container">
							<AppLoading show={loading} msg="LABELS.COMMONS.LOGIN.LOADING" />
							<div className="sds-form-group">
								<h5>
									<strong>
										<FormattedHTMLMessage id="LABELS.COMMONS.PORTAL.PORTAL_DE_SERVICOS" />
									</strong>
								</h5>
							</div>
							<div className="sds-form-group">
								<h6>
									<FormattedHTMLMessage id="LABELS.COMMONS.LOGIN.TITULO" />
								</h6>
							</div>

							<div className="sds-form-group">
								<FormattedHTMLMessage id="textoPfGovBr" defaultMessage="Pessoa Física" />
							</div>

							{usarObrasGov && (
								<>
									<div className="sds-form-group">
										<SdsButton
											fullwidth
											br20
											govBr
											onClick={() =>
												window.open(
													`${
														window.location.origin
													}/portal-servicos-oauth/oauth2/authorize/govbr?redirect_uri=${
														window.location.origin
													}/portal-servicos-frontend/oauth2/redirect`,
													'_self'
												)
											}
											label="Entrar com gov.br"
										/>
									</div>

									<div className="sds-form-group">
										<div className="separator">
											<Divider>
												<span className="span-ou">ou</span>
											</Divider>
										</div>
									</div>
								</>
							)}

							{/* Utilizando para teste o login do github */}
							{/* <div className="sds-form-group">
								<SdsButton
								raised 
								fullwidth
								className="br-button primary mt-3 mt-sm-0 ml-sm-3"
								onClick={() => window.open(`${window.location.origin}/portal-servicos-oauth/oauth2/authorize/govbr?redirect_uri=${window.location.origin}/oauth2/redirect`, '_self')}
								label="Entrar com gov.br"/>
							</div> */}

							<div className="sds-form-group">
							<p className="sds-p">
								<FormattedHTMLMessage id="textoLoginPortal" defaultMessage="Pessoa Jurídica, faça seu login" />
								</p>
							</div>

							<Form onSubmit={handleSubmit(fnHandleSubmit)}>
								{captchaEnabled && (
									<ReCAPTCHA
										ref={this.recaptchaRef}
										size="invisible"
										sitekey={captchaSitekey}
										onChange={fnSubmit}
									/>
								)}
								<SdsError msg={erro} />
								<Field
									autoFocus
									autoComplete="username"
									name="identificacao"
									label={labelUserName}
									type="text"
									component={SdsInput}
									validate={validateUserName}
									normalize={formatUserName}
								/>
								<Field
									autoComplete="password"
									name="senha"
									type="password"
									component={SdsInput}
									label="LABELS.COMMONS.USUARIO.SENHA"
									validate={[obrigatorio]}
								/>
								<div className="sds-form-group">
									<SdsButton
										raised
										fullwidth
										type="submit"
										label="LABELS.COMMONS.LOGIN.ENTRAR"
										disabled={!valid || submitting}
									/>
								</div>
							</Form>
							<div className="sds-row sds-center-xs">
								<div className="sds-col-xs-12">
									<LinkRouterStyled
										to={{
											pathname: ROUTES.RECUPERAR_SENHA.path,
											state: { identificacao: identificacao }
										}}
										className="sds-link">
										<FormattedMessage id="LABELS.COMMONS.LOGIN.ESQUECEU_A_SENHA" />
									</LinkRouterStyled>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="sds-margin-vertical sds-row sds-center-xs">
					<div className="sds-col-xs-12">
						<p className="sds-p">
							<FormattedMessage
								id="LABELS.COMMONS.LOGIN.NAO_POSSUI_CONTA"
								values={{
									'route-to-criar-conta': (
										<LinkRouterStyled to={ROUTES.CRIAR_CONTA.path} className="sds-link">
											<FormattedMessage id="LABELS.COMMONS.LOGIN.CRIAR_CONTA" />
										</LinkRouterStyled>
									)
								}}
							/>
						</p>
					</div>
				</div>
			</section>
		);
	}
}

LoginForm.defaultProps = {
	erro: undefined,
	redirectUrl: undefined
};

LoginForm.propTypes = {
	login: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	captchaEnabled: PropTypes.bool.isRequired,
	captchaSitekey: PropTypes.string,
	redirectUrl: PropTypes.string,
	erro: PropTypes.string
};

const FORM_ID = 'form_login';

function mapStateToProps(state) {
	return {
		formLoginValues: getFormValues(FORM_ID)(state),
		valid: isValid(FORM_ID)(state),
		submitting: isSubmitting(FORM_ID)(state),
		config: configuracacoesSelector.getValorConfiguracao(
			state,
			configConst.APPLICATION_CONFIG_RESOURCES
		)
	};
}

export default compose(
	connect(mapStateToProps),
	reduxForm({ form: FORM_ID, touchOnChange: true, touchOnBlur: false }),
	injectIntl
)(LoginForm);
